(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Find all video popup blocks on the page
    const videoPopupBlocks = document.querySelectorAll('.video-popup');
    
    videoPopupBlocks.forEach(function(block) {
      const blockId = block.id;
      const modalButton = block.querySelector('.video-popup__button');
      const dialog = block.querySelector(`#video-dialog-${blockId.replace('video-popup-', '')}`);
      const closeButton = block.querySelector('.video-popup__close');
      
      // Find the closest .image-block that's a sibling in the same container
      const parentContainer = block.closest('[class*="block-"]') || block.parentElement;
      const imageBlock = parentContainer?.querySelector('.image-block');
      
      // console.log(`Setting up video popup: ${blockId}`, { modalButton, dialog, closeButton, imageBlock });
      
      // Make the modal button open the modal
      if (modalButton && dialog) {
        modalButton.addEventListener('click', function() {
          // console.log(`Opening dialog for block: ${blockId}`);
          dialog.showModal();
        });
      }
      
      // Make the image block clickable to open the modal
      if (imageBlock && dialog) {
        imageBlock.style.cursor = 'pointer';
        imageBlock.addEventListener('click', function() {
          // console.log(`Opening dialog from image for block: ${blockId}`);
          dialog.showModal();
        });
      }
      
      // Function to pause/stop video
      function pauseVideo() {
        const video = dialog.querySelector('video');
        const iframe = dialog.querySelector('iframe');
        
        if (video) {
          video.pause();
          video.currentTime = 0; // Reset to beginning
          // console.log(`Video paused and reset for block: ${blockId}`);
        }
        
        if (iframe) {
          // For YouTube/Vimeo iframes, we need to reload to stop
          const currentSrc = iframe.src;
          iframe.src = currentSrc;
          // console.log(`Iframe reloaded to stop video for block: ${blockId}`);
        }
      }
      
      // Make the close button close the modal and pause video
      if (closeButton && dialog) {
        closeButton.addEventListener('click', function() {
          // console.log(`Closing dialog for block: ${blockId}`);
          pauseVideo();
          dialog.close();
        });
      }
      
      // Close modal when clicking outside and pause video
      if (dialog) {
        dialog.addEventListener('click', function(e) {
          if (e.target === dialog) {
            // console.log(`Closing dialog from outside click for block: ${blockId}`);
            pauseVideo();
            dialog.close();
          }
        });
      }
      
      // Also pause video when dialog is closed (handles ESC key and other close methods)
      dialog.addEventListener('close', function() {
        pauseVideo();
        // console.log(`Dialog closed event triggered for block: ${blockId}`);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
